// extracted by mini-css-extract-plugin
module.exports = {"error-info-container":"login-error_error-info-container__oofpa"};